<template>
  <b-card>
    <templates-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :permissao-delete-props="false"
      :permissao-imprimir="true"
      :filtros="filtros"
      class="lista-templates"
    >
      <template
        slot="celula-personalizada"
        slot-scope="{ props }"
      >
        <span v-if="props.column.field === 'tipoProposta'">
          {{ descricaoTipoProposta(props.row.tipoProposta) }}
        </span>
      </template>
    </templates-list>
  </b-card>
</template>

<style lang="scss">
.lista-templates {
  .th-acao {
    width: 10.5rem !important;
  }
}
</style>

<script>
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/services/api'

export default {
  name: 'TemplatePropostaVisualizacao',
  components: {
    templatesList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Descrição',
          field: 'descricao',
          editable: true,
        },
        {
          label: 'Tipo de proposta',
          field: 'tipoProposta',
          type: 'personalizada',
        },
      ],
      filtros: [{ colunas: ['TipoProposta', 'Descricao'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    descricaoTipoProposta(codigo) {
      if (codigo === 'constituicao') {
        return 'Proposta honorários empresas em constituição'
      }
      if (codigo === 'transferencia' || codigo === 'transeferencia') {
        return 'Proposta honorários empresas em constituição & transferência'
      }
      return ''
    },
    carregar(page, pageSize, filtros) {
      return api.getTemplates(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-template-proposta' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-template-proposta', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens

      return new Promise((resolve, reject) => {
        const promises = itensInner.map(item => api.deleteTemplate(item.id))

        Promise.all(promises)
          .then(() => resolve())
          .catch(err => {
            if (
              err.response
              && err.response.data
              && err.response.data.message
              && err.response.data.message.includes('error occurred while updating the entries')
            ) {
              this.$erro('Não é permitido realizar a exclusão deste template, pois existe vínculo com as propostas.')
            } else {
              reject(err)
            }
          })
      })
    },
  },
}
</script>
